import { useEffect, useState } from "react";
import ProductList from "./ProductList";
import { getBestSellers } from "utils/LaravelApi/LaravelAPI";

export default function BestSellerSection() {
  /* Variable con todos los Id's e informacion de los productos */
  const [products, setProducts] = useState([]);

  /* Obtiene todos los productos */
  async function getBestSellersProducts() {
    const response = await getBestSellers();
    if(response.status === 200){
      setProducts(response.data);
    }
  }

  useEffect(() => {
    getBestSellersProducts();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <ProductList products={products} />
    </div>
  );
}
